import { render } from "./PageIsiFormulirBerasa.vue?vue&type=template&id=34d27473"
import script from "./PageIsiFormulirBerasa.vue?vue&type=script&lang=js"
export * from "./PageIsiFormulirBerasa.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__